export enum InputFileState {
    EMPTY = 'EMPTY',
    LOADING = 'LOADING',
    ERROR = 'ERROR',
}
export enum FileUploadStatus {
    Uploading = 'Uploading',
    Success = 'Success',
    Error = 'Error',
}
